import { createContext, useContext } from 'react';

import type { LabContext } from './types';

const labContext = createContext<LabContext | null>(null);

/** Wraps a lab with the host-provided `LabContext`. Only the host renders this. */
export const LabContextProvider = labContext.Provider;

/** Reads the host context inside a lab. Throws outside a `LabContextProvider`. */
export const useLab = () => {
  const value = useContext(labContext);

  if (value === null) {
    throw new Error('useLab must be used inside a LabContextProvider');
  }

  return value;
};
